export default __webpack_public_path__ + "static/media/tpaita6.026f8bc3.jpg";